// Thumbnail/PresetTemplates.js

import React from 'react';

function PresetTemplates({ onApplyPreset, language }) {
    const presetButtons = [
        { key: 'vintage', icon: '🎵', label: language === 'KR' ? '빈티지 음악' : 'Vintage Music' },
        { key: 'romantic', icon: '💕', label: language === 'KR' ? '로맨틱' : 'Romantic' },
        { key: 'nature', icon: '🌿', label: language === 'KR' ? '자연' : 'Nature' },
        { key: 'winter', icon: '❄️', label: language === 'KR' ? '겨울' : 'Winter' },
        { key: 'spring', icon: '🌸', label: language === 'KR' ? '봄' : 'Spring' },
        { key: 'ocean', icon: '🌊', label: language === 'KR' ? '바다' : 'Ocean' },
        { key: 'sunset', icon: '🌅', label: language === 'KR' ? '석양' : 'Sunset' },
        { key: 'rainy', icon: '🌧️', label: language === 'KR' ? '비오는 날' : 'Rainy Day' }
    ];

    return (
        <div className="control-section">
            <h3>🎭 {language === 'KR' ? '빠른 템플릿' : 'Quick Templates'}</h3>
            <div>
                {presetButtons.map(preset => (
                    <button
                        key={preset.key}
                        className="preset-btn"
                        onClick={() => onApplyPreset(preset.key)}
                    >
                        {preset.icon} {preset.label}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default PresetTemplates;